import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../server/graphql/__generated.types';

import { ClipFragmentDoc } from '../../fragments.generated';

const defaultOptions = {} as const;
export type CreateClipMutationVariables = Types.Exact<{
  inputs: Types.CreateClipInputs;
}>;

export type CreateClipMutation = {
  __typename?: 'Mutation';
  createClip: {
    __typename?: 'CreateClipMutationResponse';
    code: string;
    success: boolean;
    message: string;
    clip?: {
      __typename?: 'Clip';
      id: string;
      projectId: string;
      name: string;
      createdAt: string;
      actorId: string;
      index: number;
      sequence: string;
      fileName: string;
      text: string;
      textFormat?: string | null;
      src: string;
      isDeleted?: boolean | null;
      isCreditableBy?: string | null;
      audioFormat: string;
      combinedFrom?: Array<string> | null;
      isComplete: boolean;
      localSrc?: string | null;
      failedWithError?: string | null;
      streamRequest?: StreamRequest | null;
      ttsVersion?: string | null;
      commentCount?: number | null;
      unviewedCommentCount?: number | null;
      actor: {
        __typename?: 'ClipActor';
        id: number;
        image: string;
        name: string;
        initials: string;
        isCustomActor?: boolean | null;
        variant: {
          __typename?: 'ActorVariant';
          id: number;
          locale: string;
          version: string;
          isArchived?: boolean | null;
          variantType: {
            __typename?: 'ActorVariantType';
            id: Types.ActorVariantTypeId;
            label: string;
            description?: string | null;
          };
          versions: {
            __typename?: 'ActorVariantVersions';
            previous?: {
              __typename?: 'TTSModelRelease';
              model: string;
              label: string;
              description?: string | null;
              overrideSpeakerVariantId?: number | null;
              features: Array<string>;
            } | null;
            latest: {
              __typename?: 'TTSModelRelease';
              model: string;
              label: string;
              description?: string | null;
              overrideSpeakerVariantId?: number | null;
              features: Array<string>;
            };
            next?: {
              __typename?: 'TTSModelRelease';
              model: string;
              label: string;
              description?: string | null;
              overrideSpeakerVariantId?: number | null;
              features: Array<string>;
            } | null;
            preview?: {
              __typename?: 'TTSModelRelease';
              model: string;
              label: string;
              description?: string | null;
              overrideSpeakerVariantId?: number | null;
              features: Array<string>;
            } | null;
          };
        };
      };
    } | null;
  };
};

export const CreateClipDocument = gql`
  mutation createClip($inputs: CreateClipInputs!) {
    createClip(inputs: $inputs) {
      code
      success
      message
      clip {
        ...ClipFragment
      }
    }
  }
  ${ClipFragmentDoc}
`;
export type CreateClipMutationFn = Apollo.MutationFunction<
  CreateClipMutation,
  CreateClipMutationVariables
>;

/**
 * __useCreateClipMutation__
 *
 * To run a mutation, you first call `useCreateClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClipMutation, { data, loading, error }] = useCreateClipMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateClipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClipMutation,
    CreateClipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateClipMutation, CreateClipMutationVariables>(
    CreateClipDocument,
    options
  );
}
export type CreateClipMutationHookResult = ReturnType<typeof useCreateClipMutation>;
export type CreateClipMutationResult = Apollo.MutationResult<CreateClipMutation>;
export type CreateClipMutationOptions = Apollo.BaseMutationOptions<
  CreateClipMutation,
  CreateClipMutationVariables
>;
